<template>

  <div class="timeline-container" v-if="eventsDecoded.length">
    <div class="timeline-header" :style="'width:'+svgWidth+'px'">
      <div class="timeline-header-main">
        {{totalCommits}} commits in total
      </div>
      <div class="timeline-header-year">
        <el-select size="mini" :value="yearOptions[yearValueIndex]" placeholder="请选择" @change="changeYear">
          <el-option
            v-for="item in yearOptions"
            :key="item"
            :name="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="svg-container">
      <svg :width="svgWidth" :height="svgHeight" class="js-calendar-graph-svg">
        <g transform="translate(16, 20)">
          <g :transform="'translate('+ index * layoutConfigList[sizeToIndex.get(size)].rectOuterWidthX +', 0)'" v-for="(item, index) in eventsDecoded">
            <rect class="day" :width="layoutConfigList[sizeToIndex.get(size)].rectInnerWidth" :height="layoutConfigList[sizeToIndex.get(size)].rectInnerWidth"
                  :x="layoutConfigList[sizeToIndex.get(size)].rectOuterWidthX"
                  :y="index===0?layoutConfigList[sizeToIndex.get(size)].rectOuterWidthY*(cindex+7-item.length):layoutConfigList[sizeToIndex.get(size)].rectOuterWidthY*cindex"
                  :fill="getRectColor(citem)"
                  v-for="(citem, cindex) in item"
                  @click="()=>{selectCertain(citem)}"
                  @mouseenter="(e)=>{hoverCertain(e,citem)}"
                  @mouseleave="(e)=>{outOfCertain(e,citem)}">
            </rect>
          </g>
          <text :x="item.left" :y="-13"
                class="month" v-for="(item, index) of monthLists"
                @click="()=>{switchMonth(item.month)}">
            {{monthShow[item.month]}}
          </text>
          <text text-anchor="start" class="wday" dx="-14" dy="8">Mon</text>
          <text text-anchor="start" class="wday" dx="-14" :dy="layoutConfigList[sizeToIndex.get(size)].rectOuterWidthY * 2 + 8">Wed</text>
          <text text-anchor="start" class="wday" dx="-14" :dy="layoutConfigList[sizeToIndex.get(size)].rectOuterWidthY * 4 + 8">Fri</text>
        </g>
      </svg>
    </div>

    <div class="activity-container" :style="'width:'+svgWidth+'px'">
      <div class="activity-container-li" v-for="(item, index) in activeLists">
        <h3 class="activity-heading">
          <strong>{{item.YYYYMMDD}}</strong>
        </h3>
        <ul class="activity-ul" v-if="item.list.length">
          <li class="activity-li"  v-for="(citem, cindex) in item.list">
            <div class="activity-li-time">
              <div class="round-time">{{citem.HH}}</div>
              <div class="header-time">{{citem.HHmmss}}</div>
            </div>
            <div class="activity-li-content" v-html="citem.content">
            </div>
          </li>
        </ul>
        <div class="activity-nocommit" v-if="!item.list.length">
          <p>No Commit</p>
        </div>
      </div>

      <div class="activity-page" v-if="showAll && totalCommits">
        <el-pagination
          layout="prev, pager, next"
          :total="totalActiveDays"
          :page-size="showAllConfig.step"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapToGrad, deepCopy, scrollTo} from './utils'
  import moment from 'moment';
  import { colorGrad, colorGradActive, type1, type2, monthShow, demoURL} from './config'
  import axios from 'axios';
  // import Vue from 'vue'
  import { Select, Option, Pagination } from 'element-ui'
  import 'element-ui/lib/theme-chalk/select.css'
  import 'element-ui/lib/theme-chalk/select-dropdown.css'
  import 'element-ui/lib/theme-chalk/option.css'
  import 'element-ui/lib/theme-chalk/pagination.css'

  // Vue.component(Select.name, Select)
  // Vue.component(Pagination.name, Pagination)
  // Vue.component(Option.name, Option)
  // Vue.config.productionTip = false;

  // 区分全局注册和局部注册

  export default {
    components:{
      [Select.name]:Select,
      [Pagination.name]:Pagination,
      [Option.name]:Option
    },
    name: 'TimeLine',
    data () {
      return {
        layoutConfigList:[
          {
            rectInnerWidth: 10,
            rectOuterWidthX: 13,
            rectOuterWidthY: 12,
          },{
            rectInnerWidth: 13,
            rectOuterWidthX: 16,
            rectOuterWidthY: 15,
          },{
            rectInnerWidth: 15,
            rectOuterWidthX: 18,
            rectOuterWidthY: 17,
          }
        ],
        data: {
          begin:null,
          end:null,
          beginDay:null,
          events:[]
        },
        type1: type1,
        type2: type2,
        msg: 'Welcome to Your Vue.js App',
        eventsDecoded:[],
        colorGrad,
        colorGradActive,
        activeLists:[],
        svgTipText:'',
        monthShow,
        activeMonth:-1,
        monthLists:[], // 显示的月份以及其位置
        totalCommits:null,
        showAllConfig:{ // 我们可以一次性显示多天的内容，默认一次性50天
          begin: 0,
          step: 20,
        },
        showAll:true,
        sizeToIndex: new Map([['s',0],['m',1],['l',2]]),
        yearValueIndex:0
      }
    },
    props:{
      requestURL:{
        type:String,
        default:demoURL
      },
      yearOptions:{
        type: Array,
        default:function () {return [2018,2017,2016,2015] },
      },
      size:{
        type:String,
        default: 'l'
      },
      topPosition:{
        type:Number,
        default:0,
      },
      autoScrollToTop:{
        type:Boolean,
        default:true,
      }
    },
    computed:{
      svgWidth:function () {
        return this.layoutConfigList[this.sizeToIndex.get(this.size)].rectOuterWidthX * this.eventsDecoded.length + 30
      },
      svgHeight:function () {
        return this.layoutConfigList[this.sizeToIndex.get(this.size)].rectOuterWidthY * 7 + 20
      },
      totalActiveDays: function () {
        let total = 0;

        for(let item of this.data.events){
          if(item.list.length)
            total += 1;
        }

        return total
      },
    },
    created () {
      this.getThisYearData();

    },
    methods: {
      computeTotalCommits(){ // 计算当年的总共提交数目
        let total = 0;

        for(let item of this.data.events){
          total += item.list.length;
        }

        this.totalCommits = total
      },
      getRectColor(citem){ // 计算一个小方格内的颜色
        if((new Date(citem.timeStamp)).getMonth() === this.activeMonth){
          return colorGradActive[mapToGrad(citem.list.length)]
        } else {
          return colorGrad[mapToGrad(citem.list.length)]
        }
      },
      switchMonth: function (month) { // 切换月份的活跃状态
        if(this.activeMonth === month){
          this.activeMonth = -1;
        } else {
          this.activeMonth = month;
        }
      },
      getThisYearData: function () { // 得到当年的详细数据
        let query = {};
        let s1 = new Date();

        if(s1.getFullYear()!==this.yearOptions[this.yearValueIndex]){
          s1 = new Date((this.yearOptions[this.yearValueIndex] + 1) + '-01-01');
        }

        query.end = s1.getTime();
        query.begin = Number(new Date((s1.getFullYear()-1) + '-' + ((s1.getMonth() + 1) < 10 ? "0" + (s1.getMonth() + 1) : (s1.getMonth() + 1) ) + '-' + ( s1.getDate() < 10 ? "0" + s1.getDate() : s1.getDate())))

        axios.get(this.requestURL,{
          params: {
            begin: query.begin,
            end:query.end
          }
        }).then( (response) => {
          console.log('gettimeline_githublike:',response);
          this.data = response.data.content;
          let beginDay = this.data.beginDay;
          if(beginDay === 0) beginDay = 7; // 我们把周一当作一周的第一天

          let firstStep = 7 - beginDay + 1;
          this.eventsDecoded = [this.data.events.slice(0, firstStep)];

          for(let i = firstStep; i < this.data.events.length; i += 7){
            this.eventsDecoded.push(this.data.events.slice(i, i + 7))
          }
          this.computeTotalCommits();

          if(this.showAll){
            this.showAllAndPage();
          }

          setTimeout(()=>{
            this.getLastYearMonth();
          })

        })
          .catch(function (error) {
            console.log(error);
          });
      },

      getLastYearMonth(){ // 获取当前年份的月份信息与排布

        let monthLists = [];
        monthLists[0] = {
          month:(new Date(this.eventsDecoded[0][this.eventsDecoded[0].length - 1].timeStamp)).getMonth(),
          left: this.layoutConfigList[this.sizeToIndex.get(this.size)].rectOuterWidthX,
        };

        for(let item of this.eventsDecoded){
          let lastDaysMonth = (new Date(item[item.length - 1].timeStamp)).getMonth();
          if(monthLists[monthLists.length - 1].month !== lastDaysMonth){
            monthLists.push({
              month: lastDaysMonth,
              left: this.layoutConfigList[this.sizeToIndex.get(this.size)].rectOuterWidthX * (this.eventsDecoded.indexOf(item) + 1)
            })
          }
        }

        if(this.layoutConfigList[this.sizeToIndex.get(this.size)].rectOuterWidthX + monthLists[0].left >=  monthLists[1].left){
          monthLists.shift();
        }

        this.monthLists = monthLists;
      },

      changeYear: function (value) { // 切换当前年份
        this.showAll = true;
        this.yearValueIndex = this.yearOptions.indexOf(value);
        this.getThisYearData();
      },

      mapToGrad: mapToGrad, // 条目与颜色对应转换

      selectCertain(citem){ // 选择特定的一天展示详细内容

        this.showAll = false;
        let activeLists = [], tpActiveLi = {};

        tpActiveLi.YYYYMMDD = moment(citem.timeStamp).format('YYYY-MM-DD');
        tpActiveLi.list = [];
        for(let item of citem.list){
          console.log('item.timeStamp:',item.timeStamp);
          tpActiveLi.list.push({
            HH:moment(parseInt(item.timeStamp)).format('HH'),
            HHmmss:moment(parseInt(item.timeStamp)).format('HH:mm:ss'),
            content:item.content
          })
        }
        activeLists.push(tpActiveLi);

        this.activeLists = activeLists;
      },

      showAllAndPage(){ // 显示全部与分页
        console.log('this.showAllAndPage...');

        let items = deepCopy(this.data.events);
        items = items.reverse().slice(this.showAllConfig.begin, this.showAllConfig.begin + this.showAllConfig.step);

        let activeLists = [];
        let tpActiveLi = {};

        for(let item of items){
          if(!item.list.length) continue;
          tpActiveLi = {};
          tpActiveLi.YYYYMMDD = moment(item.timeStamp).format('YYYY-MM-DD');
          tpActiveLi.list = [];
          for(let citem of item.list){
            tpActiveLi.list.push({
              HH:moment(parseInt(citem.timeStamp)).format('HH'),
              HHmmss:moment(parseInt(citem.timeStamp)).format('HH:mm:ss'),
              content:citem.content
            })
          }
          activeLists.push(tpActiveLi);
        }

        this.activeLists = activeLists;
      },

      handlePageChange(page){
        console.log('page:',page);
        this.showAllConfig.begin = this.showAllConfig.step * (page - 1);
        this.showAllAndPage();
        scrollTo(0);
      },

      hoverCertain(e,citem){ // 鼠标划过特定一天, 并展示tip
        let a = document.createElement("div");
        a.classList.add("svg-tip", "svg-tip-one-line");
        let o = document.createElement("strong");
        o.innerHTML = "<span class='stress-tip'>" + citem.list.length + "</span>" + " commits in total" + " | <span class='stress-tip'> " + moment(citem.timeStamp).format('MM-DD') + "</span>";
        a.appendChild(o);
        window.document.body.appendChild(a);
        this.a = a;
        // 这个其实并不是特别正, 相当于GitHub用了一个视觉上的小技巧
        let left = e.target.getBoundingClientRect().left - a.offsetWidth / 2 + e.target.getAttribute("width")/2;
        let top =  e.target.getBoundingClientRect().top - a.offsetHeight - e.target.getAttribute("height");
        a.style.top = top + "px";
        a.style.left = left + "px";
      },

      outOfCertain(e,citem){ // 鼠标划出特定一天
        window.document.body.removeChild(this.a);
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">

  .svg-tip-one-line {
    white-space: nowrap;
  }
  .svg-tip {
    position: absolute;
    z-index: 99999;
    padding: 10px;
    font-size: 12px;
    color: #a5adb5;
    text-align: center;
    background: rgba(0,0,0,0.8);
    border-radius: 3px;
  }
  .svg-tip::after {
    position: absolute;
    bottom: -10px;
    left: 50%;
    width: 5px;
    height: 5px;
    box-sizing: border-box;
    margin: 0 0 0 -5px;
    content: " ";
    border: 5px solid transparent;
    border-top-color: rgba(0,0,0,0.8);
  }
  .stress-tip{
    color: #f3f4f7;
  }

</style>

<style lang="less" scoped >

  @import "./TimeLine.less";

</style>



// WEBPACK FOOTER //
// src/components/TimeLine.vue